import { IPricePoint, PricePoint } from './price-point.model';

export interface IPackageV1Prestation {
  id?: string;
  companyId?: string;
  reference?: string;
  type?: string;
  currency?: string;
  prices?: IPricePoint[];
  createdAt?: string;
  updatedAt?: string;
}

export class PackageV1Prestation implements IPackageV1Prestation {
  constructor(
    public id?: string,
    public companyId?: string,
    public reference?: string,
    public type?: string,
    public currency?: string,
    public prices?: PricePoint[],
    public createdAt?: string,
    public updatedAt?: string
  ) {
    this.prices = this.prices || [];
  }
}
